import forEach from 'lodash/forEach';
import { ICategory, IIncomeCategoryData, ISelectedCategory } from '../../../types/category';
import { ISelectedTicket } from '../../../types/ticket';
import { CategoriesController as BaseCategoriesController } from '../../widget/categories/categories.controller';

class CategoriesController extends BaseCategoriesController {
  setCategories(categories: IIncomeCategoryData[], selectedTickets?: ISelectedTicket[]) {
    this.pricesSet = new Set();
    this.colors = {};

    const { selectedEvent, meta } = window.Widget.metaController;

    this.categories = categories.reduce((acc, category) => {
      const {
        d: categoryId,
        i: label,
        ex: additionalServices,
        extra,
        c: count,
        p: price,
        k: hashForbasket,
        description = '',
        paths,
        color,
        images,
        sectors,
      } = category;

      const id = meta.isPeriodical ? `${selectedEvent}_${categoryId}` : categoryId;
      this.categoriesWithTicketsIds.push(id);

      acc[id] = {
        id,
        description,
        paths,
        color,
        label,
        sectors: meta.isPeriodical ? sectors.map((s) => `${selectedEvent}_${s}`) : sectors,
        ex: additionalServices,
        extra,
        images,
      };

      if (count) {
        acc[id] = {
          ...acc[id],
          price,
          count,
          k: hashForbasket,
        };

        this.pricesSet.add(price);
        this.colors[price] = color;
      }

      return acc;
    }, {});

    if (selectedTickets) {
      const newSelectedTickets: { [key: string]: ISelectedCategory } = selectedTickets.reduce(
        (acc, ticket) => {
          if (this.categories[ticket.id]) {
            acc[ticket.id] = {
              ...this.categories[ticket.id],
              count: ticket.count,
            };
          }

          return acc;
        },
        {},
      );

      this.selectedCategories = {
        ...this.selectedCategories,
        ...newSelectedTickets,
      };
    }
  }

  getCategoriesOutlines = () => {
    const outlines: {
      [key: string]: {
        paths: string[];
        color: string;
        label: string;
        isCategory: boolean;
      };
    } = {};

    forEach(this.categories, (category: ICategory, id) => {
      if (window.Widget.isHybrid) {
        window.Widget.pricesController.pricesColors[category.price] &&
          (category.color = window.Widget.pricesController.pricesColors[category.price]);
      }

      outlines[id] = {
        paths: category.paths,
        color: category.color,
        label: category.label,
        isCategory: true,
      };
    });

    return outlines;
  };
}

export default CategoriesController;
